import React, { useState } from 'react';
import PropTypes from 'prop-types';

import FormGroup from '../../../FormGroup';
import CurrencyInput from '../../../CurrencyInput';
import Alert from '../../../Alert';
import Button from '../../../Button';
import { CURRENCY } from '../../../../../constants/currency';
import { formatPriceForDisplay } from '../../../../../util/format-money';

const propTypes = {
  onSave: PropTypes.func.isRequired,
  promptPrice: PropTypes.bool,
  minPrice: PropTypes.number,
  currency: PropTypes.oneOf(Object.values(CURRENCY)),
};

const CardDesignerNameModal = ({
  onSave,
  promptPrice = false,
  minPrice,
  currency,
}) => {
  const [name, setName] = useState('');
  // Starts empty on purpose: a pre-filled minimum is easy to miss and would
  // end up selling the print at that price.
  const [price, setPrice] = useState('');
  const [error, setError] = useState('');

  const onFormSubmit = event => {
    event.preventDefault();
    event.stopPropagation();

    if (!name.trim()) {
      return;
    }

    if (promptPrice) {
      if (!price) {
        setError('Price cannot be empty.');
        return;
      }

      if (minPrice && price < minPrice) {
        setError(
          `Price is lower than the required minimum pricing of $${formatPriceForDisplay(
            minPrice,
          )}.`,
        );
        return;
      }
    }

    onSave(name.trim(), promptPrice ? price : undefined);
  };

  return (
    <form method="post" onSubmit={onFormSubmit}>
      <h3 className="text-center mb-3">Save this print template as&hellip;</h3>

      <FormGroup
        className="mb-2"
        id="card-designer-template-name"
        name="name"
        label="Template name"
        labelType="expanded"
        placeholder="Name your template here"
        labelSrOnly
        value={name}
        onChange={({ target }) => setName(target.value)}
        autoFocus
      />

      {promptPrice && (
        <CurrencyInput
          wrapperClassName="mb-2"
          id="card-designer-template-price"
          name="price"
          label="Individual Sale Price"
          labelNote={
            minPrice ? `(min $${formatPriceForDisplay(minPrice)})` : undefined
          }
          labelTip="Custom prints can also be bundled as part of a package"
          value={price}
          placeholder={minPrice ? formatPriceForDisplay(minPrice) : '0.00'}
          onChange={value => {
            setPrice(value);
            setError('');
          }}
          currency={currency}
        />
      )}

      {error && (
        <Alert type="danger" className="mb-2">
          {error}
        </Alert>
      )}

      <div className="d-flex justify-content-center mt-2">
        <Button type="submit" disabled={!name.trim()}>
          Save
        </Button>
      </div>
    </form>
  );
};

CardDesignerNameModal.propTypes = propTypes;

export default CardDesignerNameModal;
